<template>
    <v-main>
        <v-container v-if="loading">
            <cardWait />
        </v-container>
        <v-container fluid class="relative ma-2" v-if="!loading">
            <v-row cols="12">
                <v-col cols="12" class="pr-6">
                    <tableVirtualConversationDetails :conversation="conversation" @updateData="updateData"/>
                </v-col>
            </v-row>
        </v-container>
        <navbar title="ARES - OpenAI" type="openai" :home="true" @actionClick="actionClick" />
    </v-main>
</template>

<script>
    import navbar from '@/components/ui/navbars/navbar.vue';

    import cardWait from '@/components/syst/openai/cardWait.vue';
    import tableVirtualConversationDetails from '@/components/syst/openai/tableVirtualConversationDetails.vue';

    export default {        
        components: {
            navbar,
            cardWait,
            tableVirtualConversationDetails,
        },
        props: {
            id: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                loading: true,
                conversation: {},
            }
        },
        mounted() {
            this.getConversationDetails();
        },
        methods: {
            getConversationDetails() {
                this.loading = true;
                this.$axios.post("ares/json/ares/syst/openai/getConversationDetails.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getConversationDetails"
                    },
                    getConversationDetails: {
                        thread_id: this.id, 
                        message_id: "",       
                    },
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.conversation = res.data.getConversationDetails.conversation;
                        this.loading = false;
                    }
                });
            },
            // Dummy callback for navBar
            actionClick() {

            },           
            updateData(data) {
                switch (data) {
                    case "refresh":
                        this.getConversationDetails();
                        break;
                    default:
                }
            },           
        },
    }
</script>

<style scoped>
</style>
